function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import * as React from 'react';
import './every-n-schedule.scss';
import { getClassNames } from '../../utils/getClassNames';
import clone from 'clone-deep';
import { Input } from 'antd';
import { DayPartSelect } from '../day-part-select/day-part-select';
export var ALL_SCHEDULE_DAYS = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
// let CHANGE_DEBOUNCE_TIMEOUT: any;
export var EveryNSchedule = /*#__PURE__*/function (_React$Component) {
  _inherits(EveryNSchedule, _React$Component);

  var _super = _createSuper(EveryNSchedule);

  function EveryNSchedule() {
    var _this;

    _classCallCheck(this, EveryNSchedule);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {};

    _this.handleChange = function (change) {
      var _this$props$onChange, _this$props;

      (_this$props$onChange = (_this$props = _this.props).onChange) === null || _this$props$onChange === void 0 ? void 0 : _this$props$onChange.call(_this$props, _objectSpread(_objectSpread({}, _this.value), change));
    };

    return _this;
  }

  _createClass(EveryNSchedule, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setState({
                  tmpValue: this.value
                });

              case 2:
                this.handleChange();

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this2 = this,
          _this$value;

      var _this$props2 = this.props,
          type = _this$props2.type,
          className = _this$props2.className,
          disabled = _this$props2.disabled;
      return /*#__PURE__*/React.createElement("div", {
        className: getClassNames('ens-builder', className, "type-".concat(type), _defineProperty({}, 'disabled', disabled))
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
        className: "ens-span"
      }, "Every"), /*#__PURE__*/React.createElement(Input, {
        className: "ens-builder-frequency",
        size: "small",
        disabled: disabled,
        defaultValue: this.initialValue.frequency,
        value: this.value.frequency,
        onChange: /*#__PURE__*/function () {
          var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(ev) {
            var frequency;
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    frequency = ev.target.value;

                    if (!(frequency[frequency.length - 1] === '.')) {
                      _context2.next = 3;
                      break;
                    }

                    return _context2.abrupt("return");

                  case 3:
                    _context2.next = 5;
                    return _this2.setState(function (_ref2) {
                      var tmpValue = _ref2.tmpValue;
                      return {
                        tmpValue: _objectSpread(_objectSpread({}, tmpValue !== null && tmpValue !== void 0 ? tmpValue : {}), {}, {
                          frequency: frequency
                        })
                      };
                    });

                  case 5:
                    _this2.handleChange(_this2.state.tmpValue);

                  case 6:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          }));

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }(),
        addonAfter: this.getTypeText()
      }), /*#__PURE__*/React.createElement("span", {
        className: "ens-span"
      }, "on"), /*#__PURE__*/React.createElement(DayPartSelect, {
        className: "ens-builder-days",
        size: "small",
        mode: type === 'weekly' ? 'single' : 'multiple',
        disabled: disabled,
        daysOnly: true,
        dayFormat: 'ddd',
        weekBeginsOnSunday: true,
        defaultValue: this.buildAllowedDayMap(this.initialValue.allowed_days),
        value: this.buildAllowedDayMap((_this$value = this.value) === null || _this$value === void 0 ? void 0 : _this$value.allowed_days),
        onChange: /*#__PURE__*/function () {
          var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(days) {
            var dayKeys;
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    dayKeys = Object.keys(days).filter(function (d) {
                      return !!days[d];
                    });
                    _context3.next = 3;
                    return _this2.setState(function (_ref4) {
                      var tmpValue = _ref4.tmpValue;
                      return {
                        tmpValue: _objectSpread(_objectSpread({}, tmpValue !== null && tmpValue !== void 0 ? tmpValue : {}), {}, {
                          allowed_days: dayKeys
                        })
                      };
                    });

                  case 3:
                    _this2.handleChange(_this2.state.tmpValue);

                  case 4:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3);
          }));

          return function (_x2) {
            return _ref3.apply(this, arguments);
          };
        }()
      })));
    } // Default value when non is provided

  }, {
    key: "defaultValue",
    get: function get() {
      return {
        type: this.props.type,
        frequency: 1,
        allowed_days: ALL_SCHEDULE_DAYS
      };
    } // Initial calculated value

  }, {
    key: "initialValue",
    get: function get() {
      var _this$props$defaultVa;

      return clone((_this$props$defaultVa = this.props.defaultValue) !== null && _this$props$defaultVa !== void 0 ? _this$props$defaultVa : this.defaultValue);
    } // Computed value

  }, {
    key: "value",
    get: function get() {
      var _ref5, _this$props$value;

      return clone((_ref5 = (_this$props$value = this.props.value) !== null && _this$props$value !== void 0 ? _this$props$value : this.state.tmpValue) !== null && _ref5 !== void 0 ? _ref5 : this.initialValue);
    }
  }, {
    key: "getTypeText",
    value: function getTypeText() {
      return this.props.type === 'daily' ? 'day(s)' : 'week(s)';
    }
  }, {
    key: "buildAllowedDayMap",
    value: function buildAllowedDayMap(days) {
      var map = {};
      ALL_SCHEDULE_DAYS.forEach(function (d) {
        return map[d] = days.includes(d);
      }); // manual override for weekly
      //  can only have single selection currently

      if (this.props.type === 'weekly' && days.length > 1) {
        days.forEach(function (d) {
          return map[d] = false;
        });
      }

      return map;
    }
  }]);

  return EveryNSchedule;
}(React.Component);